export default "__VITE_ASSET__Cgp_m6nw__"